<template>
	<div class="bg-white all margin-left padding-lr flex-sub">
		<el-form :label-position="labelPosition" label-width="80px" :model="userinfo" :rules="rules"
			ref="formLabelAlign" class="padding-tb">
			<el-form-item label="工种类别" prop="category">
				<div class="cascadera padding-lr-sm">
					<div class="casca text-right" @click.stop="chosecrt">{{ category.join(',')}}</div>
					<div class="flex bg-white align-center cate pointer" v-if="ishowcate">
						<ul class="blobk300">
							<li class="pointer text-left flex align-center justify-between"
								v-for="(item,index) in categorylist" :key="index" @click="choseitem(item,index)">
								<div :class="onecate == index?'text-theme':''">{{item.work_categroy_name}}</div>
								<i class="el-icon-arrow-right text-lg"></i>
							</li>
						</ul>
						<ul class="blobk300">
							<li class="pointer text-left flex align-center justify-between"
								v-for="(item,index) in categorytwolist" :key="index" @click="chosetwo(item)">
								<div :class="item.check?'text-theme':''">{{item.work_categroy_name}}</div>
							</li>
						</ul>
					</div>
				</div>
			</el-form-item>
			<el-form-item label="身份选择" prop="identi">
				<el-select v-model="userinfo.identi" placeholder="请选择身份">
					<el-option :label="item.name" v-for="(item,index) in identity" :key="index" :value="item.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="工作经验" prop="experience">
				<div class="padding-lr-sm">
					<el-input type="years" v-model.number="userinfo.experience" autocomplete="off"
						placeholder="请编辑工作经验">
					</el-input>
				</div>
			</el-form-item>
			<el-form-item label="期望结算" prop="settlement">
				<el-select v-model="userinfo.settlement" placeholder="请选择">
					<el-option v-for="(item,index) in array" :key="index" :label="item.name" :value="index">
					</el-option>
				</el-select>
			</el-form-item>

			<el-form-item label="期望薪资" prop="salary">
				<div class="padding-lr-sm">
					<el-input type="number" v-model.number="userinfo.salary" autocomplete="off" placeholder="可面议">
					</el-input>
				</div>
			</el-form-item>
			<el-form-item label="期望区域" prop="address">
				<!-- <el-cascader :options="addressname" :disabled="addressdisabled" v-model="address" :props="addressprops" clearable> </el-cascader> -->
				<div class="cascadera padding-lr-sm">
					<div class="casca text-right" @click.stop="chosecit">{{ addressinfo.join(',')}}</div>
					<div class="flex bg-white align-center cate pointer" v-if="ishowcity">
						<ul class="blobk300">
							<li class="pointer text-left flex align-center justify-between"
								v-for="(item,index) in provinceList" :key="index" @click="chooseProvince(item,index)">
								<div :class="item.ischeck?'text-theme':''">{{item.name}}</div>
								<i class="el-icon-arrow-right text-lg"></i>
							</li>
						</ul>
						<ul class="blobk300">
							<li class="pointer text-left flex align-center justify-between"
								v-for="(item,index) in cityList" :key="index" @click="chooseCity(item,index)">
								<div :class="item.ischeck?'text-theme':''">{{item.name}}</div>
							</li>
						</ul>
					</div>
				</div>
			</el-form-item>
			<el-form-item label="求职状态" prop="state">
				<el-select v-model="userinfo.state" placeholder="请选择">
					<el-option v-for="(item,index) in work_state" :key="index" :label="item.name" :value="item.name">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="求职标题" prop="title">
				<div class="padding-lr-sm">
					<el-input type="text" maxlength="50" v-model.number="userinfo.title" autocomplete="off"
						placeholder="请填写求职标题">
					</el-input>
				</div>
			</el-form-item>
			<el-form-item label="求职详情" prop="content">
				<textarea class="txtmep padding-sm bge margin-lr-sm" v-model="userinfo.content"
					placeholder="请输入详细的个人介绍例如工作经验相关内容..."></textarea>
			</el-form-item>
			<el-form-item label="自我评价" prop="evaluation">
				<textarea class="txtmep padding-sm bge margin-lr-sm" v-model="userinfo.evaluation"
					placeholder="请输入自我简介，例如多年工作经验，擅长某某工种岗位..."></textarea>
			</el-form-item>
			<el-form-item label="个人风采">
				<div class="flex margin-lr-sm">
					<div class="width700 margin-right-sm">
						<el-upload class="avatar-uploader" action="https://manage.ciiply.com/api/pc/user/upFile"
							:show-file-list="false" :on-success="handleSuccess">
							<img v-if="firstimg" :src="firstimg" class="uploadimg">
							<img v-else class="uploadimg" src="https://wz89.lzym.top/web/static/home/add.png">
						</el-upload>
					</div>
					<div class="width700 margin-right-sm">
						<el-upload class="avatar-uploader" action="https://manage.ciiply.com/api/pc/user/upFile"
							:show-file-list="false" :on-success="handletwoSuccess">
							<img v-if="secodimg" :src="secodimg" class="uploadimg">
							<img v-else class="uploadimg" src="https://wz89.lzym.top/web/static/home/add.png">
						</el-upload>
					</div>
					<div class="width700 margin-right-sm">
						<el-upload class="avatar-uploader" action="https://manage.ciiply.com/api/pc/user/upFile"
							:show-file-list="false" :on-success="handlethreeSuccess">
							<img v-if="threeimg" :src="threeimg" class="uploadimg">
							<img v-else class="uploadimg" src="https://wz89.lzym.top/web/static/home/add.png">
						</el-upload>
					</div>
				</div>
			</el-form-item>
			<el-button type="primary" @click="submitForm()">立即创建</el-button>
			<p class="text-xs text-999">发布成功后，平台会在1个工作日内审核完成即可显示</p>
		</el-form>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	export default {
		data() {
			return {
				addarea: [],
				addressinfo: [], //展示城市类别
				ishowcate: false, //
				ishowcity: false, //
				labelPosition: 'left',
				categorylist: [], //工种类别列表
				category: [], //展示得工种类别
				work_type_id: 0, //工种类别id1
				work_type_id2: 0, //工种类别id2
				work_type_id3: 0, //工种类别id3
				onecate: 0, //选择得一级工种
				categorytwolist: [], //选择得一级下得二级工种
				categoryprops: {
					// multiple: true,
					label: 'work_categroy_name',
					children: 'two',
					value: 'id'
				},
				userinfo: {
					category: '', //工种类别
					identi: '', //身份选择
					experience: '', //工作经验
					settlement: '', //结算方式
					salary: '', //期望薪资
					address: '', //期望区域
					state: '', //求职状态
					title: '', //求职标题
					content: '', //求职详情
					evaluation: '', //自我评价
				},
				firstimg: '', //自我风采照片
				secodimg: '', //自我风采照片
				threeimg: '', //自我风采照片
				provinceList: [], // 省列表
				cityList: [], //市
				identity: [{
					name: '个人',
					id: 0
				}, {
					name: '班组',
					id: 1
				}, {
					name: '施工队',
					id: 2
				}, {
					name: '突击队',
					id: 3
				}, ], //身份列表
				array: [{
					name: '日结'
				}, {
					name: '月结'
				}, {
					name: '可面议'
				}], //结算方式列表
				work_state: [{
						name: '正在找工作'
					},
					{
						name: '已找到工作'
					},
					{
						name: '正在干活，预定下个活'
					}
				], //求职状态
				rules: {
					category: [{
						required: true,
						message: '请选择工种类别',
						trigger: 'change'
					}],
					identi: [{
						required: true,
						message: '请选择身份',
						trigger: 'change'
					}],
					experience: [{
						required: true,
						message: '请编辑工作经验',
						trigger: 'blur'
					}],
					settlement: [{
						required: true,
						message: '请选择结算方式',
						trigger: 'blur'
					}],
					// address: [{
					// 	required: true,
					// 	message: '请选择期望区域',
					// 	trigger: 'change'
					// }],
					state: [{
						required: true,
						message: '请选择求职状态',
						trigger: 'change'
					}],
					title: [{
						required: true,
						message: '请填写求职标题',
						trigger: 'blur'
					}],
					content: [{
						required: true,
						message: '请输入详细的个人介绍例如工作经验相关内容',
						trigger: 'blur'
					}],
					evaluation: [{
						required: true,
						message: '"请输入自我简介',
						trigger: 'blur'
					}],
				}, //表单校验规则
			}
		},
		watch: {
			// address(val){
			// 	if(val.length == 3){
			// 		let dropdown = document.getElementsByClassName('el-cascader__dropdown')[0]
			// 		console.log('dropdown',dropdown);
			// 		this.addressdisabled = true
			// 	}
			// 	console.log('address',val);
			// 	// if(val.address)
			// }
		},
		created() {
			this.getcity()
			this.getworkCategroy()
			this.getinfo()
		},
		methods: {
			getdis() {

			},
			//上转第一张
			handleSuccess(file) {
				this.firstimg = file.data.url;
			},
			handletwoSuccess(file) {
				this.secodimg = file.data.url;
			},
			handlethreeSuccess(file) {
				this.threeimg = file.data.url;
			},
			//展示工种类别选择器
			chosecrt() {
				this.ishowcate = !this.ishowcate
			},
			//展示城市选择器
			chosecit() {
				this.ishowcity = !this.ishowcity
			},
			//工种类别一级选择
			choseitem(item, index) {
				this.onecate = index
				this.categorytwolist = item.two
			},
			//工种类别二级选择
			chosetwo(item) {
				if (!item.check) {
					item.check = true
					this.userinfo.category.push(item)
					if (this.userinfo.category.length >= 3) {
						this.ishowcate = false
					}
				} else {
					item.check = false
					let aindex;
					this.userinfo.category.map((ele, insdf) => {
						if (ele.id == item.id) {
							aindex = insdf
						}
					})
					this.userinfo.category.splice(aindex, 1)
				}
				this.category = []
				this.userinfo.category.map(ele => {
					this.category.push(ele.work_categroy_name)
				})
			},
			//获取基本信息
			getinfo() {
				this.ajax('get', '/api/pc/userInfo/myUserInfo', {
					type: 2
				}, res => {
					if (res.status == 200) {
						let userInfo = res.data.userInfo.length == 0 ? null : res.data.userInfo
						if (userInfo) {
							this.userinfo.identi = userInfo.type
							this.userinfo.content = userInfo.content
							this.userinfo.experience = userInfo.experience
							this.userinfo.evaluation = userInfo.evaluate
							this.userinfo.title = userInfo.title
							this.userinfo.salary = userInfo.wages == 0 ? '面议' : userInfo.wages
							this.userinfo.category = userInfo.category
							userInfo.category.map(ele => {
								this.category.push(ele.work_categroy_name)
							})
							if (userInfo.area) {
								this.addressinfo = userInfo.area.split(',')
							}
							this.work_type_id = userInfo.work_type_id
							this.work_type_id2 = userInfo.work_type_id2
							this.work_type_id3 = userInfo.work_type_id3
							this.userinfo.state = userInfo.work_state
							this.userinfo.settlement = userInfo.settlement
							if (userInfo.images && userInfo.images.length != 0) {
								if (userInfo.images.length == 1) {
									this.firstimg = userInfo.images[0]
								}
								if (userInfo.images.length == 2) {
									this.firstimg = userInfo.images[0]
									this.secodimg = userInfo.images[1]
								}
								if (userInfo.images.length == 3) {
									this.firstimg = userInfo.images[0]
									this.secodimg = userInfo.images[1]
									this.threeimg = userInfo.images[2]
								}
							}
							this.isShowLoading = false;
						}
					}
				})
			},
			/**
			 * 获取用工分类
			 * */
			getworkCategroy() {
				this.ajax('get', '/api/pc/workCategroy/getlist', {
					type: 2
				}, res => {
					if (res.status == 200) {
						res.data[0].two.map(item => {
							item.check = false
							if (item.id == this.work_type_id || item.id == this.work_type_id2 || item.id ==
								this.work_type_id3) {
								item.check = true
							}
						})

						this.categorylist = res.data
						this.categorytwolist = res.data[0].two
					}
				})
			},
			//获取城市列表
			getcity() {
				this.ajax('get', '/api/work/getCityList', {}, res => {
					if (res.status == 200) {
						let list = res.data;
						list.forEach(item => {
							let obj = {
								id: 0,
								level: 1,
								pid: item.id,
								name: '不限',
							}
							if (item.children){
								if(item.children.length > 1){
									item.children = [obj, ...item.children]
								}
							}else{
								item.children = [obj]
							}
							
							item.children.map(plp => {
								plp.ischeck = false
							})
						})
						this.provinceList = list;
						this.cityList = list[0].children
						if (this.addressinfo.length != 0) {
							let addressname = this.addressinfo
							let that = this
							list.map(ele => {
								ele.children.map(ala => {
									addressname.map(clc => {
										if (clc == ala.name) {
											ala.ischeck = true
											that.addarea.push(ala)
										}
									})
								})
							})
						}
					}
				})
			},
			chooseProvince(item,index) {
				this.provinceIndex = index;
				this.cityList = item.children
				// this.cityIndex = null;
			},
			chooseCity(item,index) {
				let cityId;
				let citylength = this.addarea.length
				if (!item.ischeck) {
					if(citylength < 3){
						let ala = this.provinceList[this.provinceIndex]
						if(item.id == 0){//不限
							this.addarea.push(ala)
							
							ala.children.map(clc=>{
								clc.ischeck = false
								this.addarea.map((ele,elex)=>{
									if(ele.id == clc.id){
										this.addarea.splice(elex,1)
									}
								})
							})
							item.ischeck = !item.ischeck
						}else{
							this.addarea.map((ele,elex)=>{
								if(ele.id == ala.id){
									this.addarea.splice(elex,1)
								}
							})
							this.cityIndex = index;
							item.ischeck = !item.ischeck
							this.addarea.push(item)
						}
						
					}else{
						this.$message.info('最多可选3个城市')
					}
				}else{
					item.ischeck = !item.ischeck
					let ala = this.provinceList[this.provinceIndex]
					if(item.id == 0){
						this.addarea.map((ele,elex)=>{
							if(ele.id == ala.id){
								this.addarea.splice(elex,1)
							}
						})
					}else{
						this.addarea.map((ele,elex)=>{
							if(ele.id == item.id){
								this.addarea.splice(elex,1)
							}
						})
					}
					
				}
				this.addressinfo = []
				this.addarea.map(ele => {
					this.addressinfo.push(ele.name)
				})
				
				
			},
			//立即创建
			submitForm() {
				this.$refs.formLabelAlign.validate((valid) => {
					if (valid) {
						this.subedit()
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			subedit() {
				console.log(this.userinfo.category);
				let arrid = []
				this.userinfo.category.map(ele => {
					arrid.push(ele.id)
					// if (ele.length == 2) {
					// 	arrid.push(ele[1].id)
					// } else {
					// 	arrid.push(ele[0].id)
					// }
				})
				console.log(this.addressinfo);
				let arrname = []
				this.addressinfo.map(ele => {
					arrname.push(ele)
					// if (ele.length == 2) {
					// 	arrname.push(ele[1])
					// } else {
					// 	arrname.push(ele[0])
					// }
				})
				let images = []
				if (this.firstimg) {
					images.push(this.firstimg)
				}
				if (this.secodimg) {
					images.push(this.secodimg)
				}
				if (this.threeimg) {
					images.push(this.threeimg)
				}
				let data = {
					work_type_id: arrid.join(','),
					type: this.userinfo.identi,
					wages: this.userinfo.salary ? this.userinfo.salary : '面议',
					area: arrname.join(','),
					settlement: this.userinfo.settlement,
					content: this.userinfo.content,
					experience: this.userinfo.experience,
					evaluate: this.userinfo.evaluation,
					images: images.join('|'),
					title: this.userinfo.title,
					work_state: this.userinfo.state
				}
				// return console.log(data);
				this.ajax('post', '/api/userInfo/editBasic', data, res => {
					if (res.status == 200) {
						this.$message("提交成功")
					} else {
						this.$message(res.msg);
					}
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.cascadera {
		// width: 740px;
		min-height: 54px;
		position: relative;

		.casca {
			padding: 0 10px;
			width: 100%;
			height: 54px;
			line-height: 54px;
			border: 1px solid #E6E6E6;
			border-radius: 8px;
		}

		ul,
		li {
			list-style: none;
		}

		.cate {
			overflow: hidden;
			position: absolute;
			top: 54px;
			z-index: 9;

			.blobk300 {
				height: 200px;
				min-width: 180px;
				box-sizing: border-box;
				overflow: auto;
				line-height: 35px;
				border: 1px solid #E6E6E6;
			}

			// .blobk300:hover{
			// 	overflow: auto;
			// }
		}


		::-webkit-scrollbar {
			width: 5px;
			/*高宽分别对应横竖滚动条的尺寸*/
			height: 1px;
		}

		::-webkit-scrollbar-thumb {
			/*滚动条里面小方块*/
			border-radius: 10px;
			box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
			background: #666;
			transition: background 1s;
		}

		::-webkit-scrollbar-track {
			/*滚动条里面轨道*/
			box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
			border-radius: 10px;
			background: #ededed;
		}
	}


	.el-cascader,
	.el-select {
		width: 740px;
		min-height: 54px;
	}


	.uploadimg {
		width: 129px;
		height: 122px;
		border-radius: 8px;
	}

	/deep/ .el-input>input {
		text-align: right;
		min-height: 54px;
		width: 100%;
	}

	.txtmep {
		width: 100%;
		height: 126px;
		border: 1px solid #E6E6E6;
		border-radius: 8px;
		outline: 0;
	}

	/deep/ .el-button {
		width: 383px;
		height: 46px;
		background: #09827B;
		box-shadow: 3px 4px 38px 2px rgba(9, 130, 123, 0.2000);
		border-radius: 23px;
		margin-top: 60px;
		margin-bottom: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/view/my/basic.vue